/* === block 1914-2117 === */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(min-width: 1024px)').matches) return;

    var sectionRoot = document.getElementById('shopify-section-' + window.FROG_PDP.sectionId);
    if (!sectionRoot) return;
    var isPreorderByLiquid = window.FROG_PDP.isPreorder;
    if (sectionRoot.querySelector('.buybox-cutoff-mobile')) return;

    var submitButton = sectionRoot.querySelector('.product-form__submit, .essential-preorder-initial-add-to-cart-button, button[name="add"]');
    if (!submitButton) return;

    var bar = document.createElement('div');
    bar.className = 'mobile-buybar';
    bar.innerHTML = '<div class="mobile-buybar__price">--</div><button type="button" class="mobile-buybar__cta">Aggiungi</button>';
    sectionRoot.appendChild(bar);

    var barPrice = bar.querySelector('.mobile-buybar__price');
    var barBtn = bar.querySelector('.mobile-buybar__cta');

    var findPriceText = function () {
      var el = sectionRoot.querySelector('.product__price .price__regular') || sectionRoot.querySelector('.product__price .price__current');
      if (!el) return '';
      return (el.textContent || '').trim();
    };

    var syncBuybar = function () {
      var p = findPriceText();
      if (p) barPrice.textContent = p;

      var rawLabel = (submitButton.textContent || 'Aggiungi al carrello').trim().replace(/\s+/g, ' ');
      var soldOut = submitButton.disabled || rawLabel.toLowerCase().indexOf('esaur') > -1 || rawLabel.toLowerCase().indexOf('sold out') > -1;

      if (soldOut) {
        barBtn.textContent = 'Esaurito';
        barBtn.disabled = true;
        return;
      }

      var label = rawLabel;
      if (label.length > 20) label = 'Aggiungi';
      barBtn.textContent = label || 'Aggiungi';
      barBtn.disabled = submitButton.disabled;
    };

    barBtn.addEventListener('click', function () {
      submitButton.click();
      submitButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    syncBuybar();
    setInterval(syncBuybar, 1500);

    var updateBuybarVisibility = function () {
      var doc = document.documentElement;
      var maxScrollable = Math.max(0, doc.scrollHeight - window.innerHeight);
      if (maxScrollable <= 0) {
        bar.classList.add('is-visible');
        return;
      }

      var threshold = maxScrollable * 0.3;
      if (window.scrollY >= threshold) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    };

    updateBuybarVisibility();
    window.addEventListener('scroll', updateBuybarVisibility, { passive: true });
    window.addEventListener('resize', updateBuybarVisibility);

    var cutoffBox = document.createElement('div');
    cutoffBox.className = 'buybox-cutoff-mobile';
    cutoffBox.innerHTML = '<span class="buybox-cutoff-dot" aria-hidden="true"></span><span data-cutoff-text></span>';
    submitButton.insertAdjacentElement('afterend', cutoffBox);

    var pad = function (n) { return String(n).padStart(2, '0'); };
    var getRomeNow = function () { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' })); };

    var easterDate = function (year) {
      var a = year % 19;
      var b = Math.floor(year / 100);
      var c = year % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month - 1, day);
    };

    var isSameDay = function (d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    };

    var isHoliday = function (date) {
      var fixed = ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26'];
      var key = pad(date.getMonth() + 1) + '-' + pad(date.getDate());
      if (fixed.indexOf(key) > -1) return true;
      var easter = easterDate(date.getFullYear());
      var easterMonday = new Date(easter); easterMonday.setDate(easterMonday.getDate() + 1);
      return isSameDay(date, easter) || isSameDay(date, easterMonday);
    };

    var isBusinessDay = function (date) {
      var day = date.getDay();
      return day !== 0 && day !== 6 && !isHoliday(date);
    };

    var getSectionText = function () {
      return (sectionRoot.textContent || '').toLowerCase();
    };

    var hasPreorderSignals = function () {
      if (isPreorderByLiquid) return true;
      if (submitButton && submitButton.hasAttribute('data-pre-order')) return true;
      if (sectionRoot.querySelector('[data-pre-order]')) return true;

      var preorderNode = sectionRoot.querySelector('.frog-preorder-warning, [class*="preorder"], [id*="preorder"]');
      if (preorderNode) return true;

      var t = (submitButton.textContent || '').toLowerCase();
      if (t.indexOf('preord') > -1) return true;

      var txt = getSectionText();
      return txt.indexOf('prodotto in preordine') > -1 || txt.indexOf('preordine') > -1;
    };

    var hasInStockSignals = function () {
      var txt = getSectionText();
      return txt.indexOf('in magazzino') > -1
        || txt.indexOf('pronto per la spedizione') > -1
        || txt.indexOf('ultime') > -1;
    };

    var isPreorder = function () {
      if (isPreorderByLiquid) return true;
      var preorder = hasPreorderSignals();
      var inStock = hasInStockSignals();

      if (preorder && !inStock) return true;
      if (preorder && submitButton && submitButton.hasAttribute('data-pre-order')) return true;
      return false;
    };

    var isSoldOut = function () {
      if (!submitButton) return true;
      if (submitButton.disabled) return true;
      var t = (submitButton.textContent || '').toLowerCase();
      return t.indexOf('esaur') > -1 || t.indexOf('sold out') > -1 || t.indexOf('non disponibile') > -1;
    };

    /* PAUSA OTTOBRE 2026 (solo quest'anno, non si ripete): spedizioni ferme da martedì 13 ore 11:00 a venerdì 16 ore 11:00.
       Dopo il 16 alle 11 riprende da solo il timer normale (prossimo giorno lavorativo). Non si promette una data di partenza.
       Gli stessi orari stanno in snippets/shipping-pause-popup.liquid e snippets/pausa-spedizioni-carrello.liquid.
       Si confronta con Date.now() (assoluto), non con l'ora di Roma convertita: il fuso del telefono non conta. */
    var SHIPPING_PRE_START = new Date('2026-10-12T20:00:00+02:00');
    var SHIPPING_PAUSE_START = new Date('2026-10-13T11:00:00+02:00');
    var SHIPPING_PAUSE_END = new Date('2026-10-16T11:00:00+02:00');
    var isEN = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
    var isShippingPaused = function () {
      var t = Date.now();
      return t >= SHIPPING_PAUSE_START.getTime() && t < SHIPPING_PAUSE_END.getTime();
    };
    var isPrePause = function () {
      var t = Date.now();
      return t >= SHIPPING_PRE_START.getTime() && t < SHIPPING_PAUSE_START.getTime();
    };

    var update = function () {
      var target = cutoffBox.querySelector('[data-cutoff-text]');
      if (!target) return;
      cutoffBox.classList.remove('is-next', 'is-preorder');

      if (isSoldOut()) {
        cutoffBox.style.display = 'none';
        return;
      }

      if (isPreorder()) {
        cutoffBox.style.display = 'none';
        return;
      }

      cutoffBox.style.display = '';

      var now = getRomeNow();
      var cutoff = new Date(now); cutoff.setHours(11, 0, 0, 0);

      if (isShippingPaused()) {
        var isFriday = now.getDay() === 5;
        target.textContent = isEN
          ? (isFriday ? 'We are changing warehouse to host many more games: back to normal from 11 am today' : 'We are changing warehouse to host many more games: back to normal from Friday 11 am')
          : (isFriday ? 'Stiamo cambiando magazzino per ospitare più giochi: dalle 11 di oggi torna tutto normale' : 'Stiamo cambiando magazzino per ospitare più giochi: da venerdì alle 11 torna tutto normale');
        cutoffBox.classList.add('is-next');
      } else if (isBusinessDay(now)) {
        target.textContent = isEN ? 'Order now: we\'ll get it ready as soon as we can' : 'Ordina ora: lo prepariamo il prima possibile';
        if (isPrePause()) target.textContent += isEN ? ' · then warehouse move until Friday' : ' · poi cambio magazzino fino a venerdì';
      } else {
        target.textContent = isEN ? 'Order now: we\'ll get it ready on the next working day' : 'Ordina ora: lo prepariamo il prossimo giorno lavorativo';
        if (isPrePause() && now.getDay() === 1) {
          target.textContent = isEN ? 'Order now: ships tomorrow morning, before the warehouse move' : 'Ordina ora: parte domattina, prima del cambio magazzino';
        }
        cutoffBox.classList.add('is-next');
      }
    };

    update();
    setInterval(update, 1000);
  });

/* === block 3073-3432 === */
      (() => {
        const CATEGORY_MAP = {
          "Cooperative Game":"https://frogames.it/collections/cooperativi",
          "Strategy Game":"https://frogames.it/collections/strategia",
          "Wargame":"https://frogames.it/collections/wargame",
          "Thematic":"https://frogames.it/collections/tematici",
          "Party Game":"https://frogames.it/collections/party-games",
          "Abstract Game":"https://frogames.it/collections/astratti",
          "Family Game":"https://frogames.it/collections/family-game",
          "Two Players":"https://frogames.it/collections/giochi-da-tavolo-per-2-giocatori",
          "Solo":"https://frogames.it/collections/solitari"
        };

        const bggId = window.FROG_PDP.bggId;
        if (!bggId) return;

        const $ = (sel) => document.querySelector(sel);

        /* ===== HOTNESS BADGE ===== */
        fetch(`https://frogames-bgg-updater.onrender.com/hot?id=${bggId}`)
          .then(r => r.json())
          .then(d => {
            if (!d?.isHot || !d.rank) return;

            let cls = "hot-top50";
            if (d.rank <= 10) cls = "hot-top10";
            else if (d.rank <= 25) cls = "hot-top25";

            const chipHTML =
              `<a class="hotness-chip ${cls}"
                  href="https://boardgamegeek.com/hotness"
                  target="_blank" rel="noopener"
                  aria-label="BGG Hotness rank #${d.rank}">
                🔥 #${d.rank} · Hotness BGG
              </a>`;

            const inject = (retries = 15) => {
              const row = $("#bgg-rank-row");
              const wrapper = document.getElementById("bgg-wrapper");
              if (row) {
                if (!row.dataset.hotnessInjected) {
                  row.insertAdjacentHTML("beforeend", chipHTML);
                  row.dataset.hotnessInjected = "1";
                }
                if (wrapper && !wrapper.classList.contains(cls)) wrapper.classList.add(cls);
              } else if (retries > 0) {
                setTimeout(() => inject(retries - 1), 250);
              }
            };

            if (document.readyState === "loading") {
              document.addEventListener("DOMContentLoaded", () => setTimeout(inject, 300), { once: true });
            } else {
              setTimeout(inject, 300);
            }
          })
          .catch(() => {});

        /* ===== STATS + POLLS ===== */
        fetch(`https://frogames-bgg-updater.onrender.com/thing?id=${bggId}&stats=1&polls=1`)
          .then(r => r.text())
          .then(str => new DOMParser().parseFromString(str, "text/xml"))
          .then(data => {
            const gv = (tag) => data.querySelector(tag)?.getAttribute("value") || "";

            const rating = parseFloat(gv("average"));
            const votes  = gv("usersrated");
            const weight = parseFloat(gv("averageweight"));
            const minT   = gv("minplaytime");
            const maxT   = gv("maxplaytime");
            const minAge = gv("minage");
            const year   = gv("yearpublished");
            const minP   = gv("minplayers");
            const maxP   = gv("maxplayers");

            if ($("#bgg-rating")) $("#bgg-rating").textContent =
              `🐸 BGG Rating: ${isFinite(rating) ? rating.toFixed(1) : "—"}`;
            if ($("#bgg-stars")) $("#bgg-stars").textContent =
              `${"★".repeat(Math.round(isFinite(rating) ? rating : 0))}`;
            if ($("#bgg-votes")) $("#bgg-votes").textContent =
              votes ? `Su ${votes} voti` : "";
            if ($("#bgg-year")) $("#bgg-year").textContent =
              `🗓️ Pubblicato: ${year || "—"}`;

            if ($("#players-range")) $("#players-range").textContent =
              `Giocatori: ${minP === maxP ? (minP || "—") : `${minP || "—"}–${maxP || "—"}`}`;

            /* ===== POPOLA INFO CHIAVE FUORI ===== */
            const setTxt = (id, txt) => {
              const el = document.getElementById(id);
              if (el) el.textContent = (txt && String(txt).trim()) ? txt : "—";
            };

            setTxt("frog-players", (minP && maxP) ? (minP === maxP ? minP : `${minP}–${maxP}`) : "—");
            setTxt("frog-duration", (minT && maxT)
              ? (minT === maxT ? `${minT} min` : `${minT}–${maxT} min`)
              : "—");
            setTxt("frog-age", minAge ? `${minAge}+` : "—");

            if (isFinite(weight)) {
              let wTxt = `${weight.toFixed(1)} / 5`;
              if (weight < 2) wTxt += " · Leggero";
              else if (weight < 3.5) wTxt += " · Medio";
              else wTxt += " · Complesso";
              setTxt("frog-weight", wTxt);
            } else {
              setTxt("frog-weight", "—");
            }

            /* Commento complessità */
            if (isFinite(weight) && $("#bgg-comment")) {
              let comment = "";
              if (weight < 2) comment = "💚 Perfetto per sessioni leggere e rilassate.";
              else if (weight < 3.5) comment = "🧠 Strategico, accessibile e soddisfacente.";
              else comment = "🐸 Per giocatori esperti: richiede pianificazione.";
              $("#bgg-comment").textContent = comment;
            }

            /* Rank chips */
            const rankRow = $("#bgg-rank-row");
            const overall = parseInt(data.querySelector("rank[type='subtype']")?.getAttribute("value") || "0", 10);

            let badgeHTML = "";
            if (overall) {
              if (overall <= 10) badgeHTML = "<span class='bgg-badge badge-top10'>🥇 Top 10 BGG</span>";
              else if (overall <= 50) badgeHTML = "<span class='bgg-badge badge-top50'>🥈 Top 50 BGG</span>";
              else if (overall <= 100) badgeHTML = "<span class='bgg-badge badge-top100'>🥉 Top 100 BGG</span>";
              else if (overall <= 500) badgeHTML = "<span class='bgg-badge badge-top500'>🎖️ Top 500 BGG</span>";
              else if (overall <= 1000) badgeHTML = "<span class='bgg-badge badge-top1000'>📦 Top 1000 BGG</span>";
            }
            if ($("#bgg-badge")) $("#bgg-badge").innerHTML = badgeHTML;

            if (rankRow) {
              const chips = [];
              if (overall) {
                chips.push(
                  `<a class='rank-chip rank-chip--overall' href='https://boardgamegeek.com/browse/boardgame' target='_blank' rel='noopener'>
                    📊 #${overall} · Overall
                  </a>`
                );
              }
              [...data.querySelectorAll("rank[type='family']")].forEach(r => {
                const val = r.getAttribute("value");
                const name = r.getAttribute("friendlyname") || r.getAttribute("name") || "";
                if (!val || val === "Not Ranked" || !name) return;
                const label = name.replace(/\\s*Rank$/,'').trim();
                chips.push(
                  `<a class='rank-chip' href='https://boardgamegeek.com/browse/boardgame' target='_blank' rel='noopener'>
                    #${val} · ${label}
                  </a>`
                );
              });
              rankRow.innerHTML = chips.join("");
            }

            /* Designer / Artist */
            const designers = [...data.querySelectorAll("link[type='boardgamedesigner']")]
              .map(n => n.getAttribute("value")).filter(Boolean).slice(0, 2);
            const artists = [...data.querySelectorAll("link[type='boardgameartist']")]
              .map(n => n.getAttribute("value")).filter(Boolean).slice(0, 2);

            if ($("#bgg-designer") && designers.length) {
              $("#bgg-designer").innerHTML =
                `✍️ Designer: ${designers.map(v => `<a class='bgg-link' href='/search?q=${encodeURIComponent(v)}'>${v}</a>`).join(", ")}`;
            }
            if ($("#bgg-artist") && artists.length) {
              $("#bgg-artist").innerHTML =
                `🎨 Artist: ${artists.map(v => `<a class='bgg-link' href='/search?q=${encodeURIComponent(v)}'>${v}</a>`).join(", ")}`;
            }

            /* Categorie / Meccaniche */
            const renderChips = (arr, elId) => {
              const el = $(elId);
              if (!el || !arr.length) return;

              const first = arr.slice(0, 5);
              const rest  = arr.slice(5);

              el.innerHTML = first.map(v => {
                const link = CATEGORY_MAP[v] || `/search?q=${encodeURIComponent(v)}`;
                return `<span class='chip'><a href='${link}'>${v}</a></span>`;
              }).join("");

              if (rest.length) {
                const restId = elId.replace("#","") + "-rest";
                el.insertAdjacentHTML("beforeend",
                  `<span class='showmore' id='${restId}-btn'>+${rest.length} more</span>
                   <span id='${restId}' style='display:none'>
                     ${rest.map(v => {
                       const link = CATEGORY_MAP[v] || `/search?q=${encodeURIComponent(v)}`;
                       return `<span class='chip'><a href='${link}'>${v}</a></span>`;
                     }).join("")}
                   </span>`
                );

                const btn = document.getElementById(`${restId}-btn`);
                btn?.addEventListener("click", () => {
                  btn.style.display = "none";
                  document.getElementById(restId).style.display = "inline";
                });
              }
            };

            const cats = [...data.querySelectorAll("link[type='boardgamecategory']")]
              .map(n => n.getAttribute("value")).filter(Boolean);
            const mecs = [...data.querySelectorAll("link[type='boardgamemechanic']")]
              .map(n => n.getAttribute("value")).filter(Boolean);

            renderChips(cats, "#bgg-categories");
            renderChips(mecs, "#bgg-mechanics");

            /* Dipendenza lingua */
            const pollLang = data.querySelector('poll[name="language_dependence"]');
            let langText = "Attualmente non disponibile";

            if (pollLang) {
              const results = [...pollLang.querySelectorAll("result")];
              const tot = results.reduce((a, r) => a + parseInt(r.getAttribute("numvotes") || "0", 10), 0);

              if (tot > 0) {
                const most = results.reduce((m, c) => {
                  const mv = parseInt(m.getAttribute("numvotes") || "0", 10);
                  const cv = parseInt(c.getAttribute("numvotes") || "0", 10);
                  return (cv > mv) ? c : m;
                }, results[0]);

                const value = most?.getAttribute("value") || "";
                langText = ({
                  "No necessary in-game text":"Indipendente",
                  "Some necessary text - easily memorized or small crib sheet":"Bassa",
                  "Moderate in-game text - needs crib sheet or paste ups":"Media",
                  "Extensive use of text - massive conversion needed to be playable":"Alta",
                  "Unplayable in another language":"Totale"
                }[value] || "Attualmente non disponibile");
              }
            }
            if ($("#bgg-language-val")) $("#bgg-language-val").textContent = langText;

            /* ===== PLAYERS MODAL FULLSCREEN ===== */
            const pollPlayers = data.querySelector('poll[name="suggested_numplayers"]');
            const openBtn = document.getElementById("players-details-open");

            const modal = document.getElementById("players-modal");
            const modalBody = document.getElementById("players-modal-body");
            const modalSub = document.getElementById("players-modal-sub");
            const closeBtn = document.getElementById("players-modal-close");

            if (pollPlayers && openBtn && modal && modalBody && closeBtn) {
              const rows = [];

              const normalizeNum = (num) => {
                if (!num) return "";
                const m = num.match(/more than\\s*(\\d+)/i);
                if (m) return `${parseInt(m[1], 10) + 1}+`;
                return num.trim();
              };

              const sortKey = (numStr) => {
                const s = String(numStr);
                if (s.includes("+")) return (parseInt(s, 10) || 999) + 1000;
                return parseInt(s.replace(/\\D+/g, '') || '0', 10) || 0;
              };

              let pollTotalVotes = 0;

              [...pollPlayers.querySelectorAll("results")].forEach(g => {
                const numRaw = g.getAttribute("numplayers");
                const num = normalizeNum(numRaw);
                if (!num) return;

                const best = parseInt(g.querySelector('result[value="Best"]')?.getAttribute("numvotes") || "0", 10);
                const rec  = parseInt(g.querySelector('result[value="Recommended"]')?.getAttribute("numvotes") || "0", 10);
                const no   = parseInt(g.querySelector('result[value="Not Recommended"]')?.getAttribute("numvotes") || "0", 10);
                const tot  = best + rec + no;
                if (!tot) return;

                pollTotalVotes += tot;

                const bestPct = Math.round(best / tot * 100);
                const recPct  = Math.round(rec  / tot * 100);
                const noPct   = Math.round(no   / tot * 100);

                rows.push({ num, bestPct, recPct, noPct, totVotes: tot });
              });

              rows.sort((a,b)=>sortKey(a.num)-sortKey(b.num));

              modalBody.innerHTML = rows.map(r => `
                <div class="player-detail-card">
                  <div class="player-detail-top">
                    <div class="player-detail-num">👥 ${r.num} giocatori</div>
                    <div class="player-detail-votes">N. voti: ${r.totVotes}</div>
                  </div>

                  <div class="barline">
                    <div class="barlabel"><span>🟢 Ottimale</span><span>${r.bestPct}%</span></div>
                    <div class="bar"><span style="width:${r.bestPct}%;background:#22c55e"></span></div>

                    <div class="barlabel"><span>🟡 Consigliato</span><span>${r.recPct}%</span></div>
                    <div class="bar"><span style="width:${r.recPct}%;background:#f59e0b"></span></div>

                    <div class="barlabel"><span>🔴 Sconsigliato</span><span>${r.noPct}%</span></div>
                    <div class="bar"><span style="width:${r.noPct}%;background:#ef4444"></span></div>
                  </div>
                </div>
              `).join("");

              if (modalSub) modalSub.textContent = `Voti totali poll: ${pollTotalVotes || "—"}`;
              openBtn.style.display = rows.length ? "inline-block" : "none";

              /* sposta la modal nel BODY per evitare tagli/clip */
              if (!modal.dataset.moved) {
                document.body.appendChild(modal);
                modal.dataset.moved = "1";
              }

              const openModal = () => {
                modal.classList.add("is-open");
                modal.setAttribute("aria-hidden","false");
                document.documentElement.style.overflow = "hidden";
                setTimeout(() => closeBtn.focus(), 0);
              };

              const closeModal = () => {
                modal.classList.remove("is-open");
                modal.setAttribute("aria-hidden","true");
                document.documentElement.style.overflow = "";
                setTimeout(() => openBtn.focus(), 0);
              };

              openBtn.addEventListener("click", openModal);
              closeBtn.addEventListener("click", closeModal);

              modal.addEventListener("click", (e) => {
                if (e.target === modal) closeModal();
              });

              document.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
              }, { passive:true });
            }

            /* Toggle Categories / Mechanics */
            const catT = document.getElementById("cat-toggle");
            const mecT = document.getElementById("mec-toggle");
            const catB = document.getElementById("bgg-categories");
            const mecB = document.getElementById("bgg-mechanics");

            let cO=false, mO=false;
            const upd = (box, open, t) => {
              box.style.display = open ? "block" : "none";
              t.textContent = open ? "Nascondi" : "Mostra";
            };
            catT?.addEventListener("click", () => { cO=!cO; upd(catB, cO, catT); });
            mecT?.addEventListener("click", () => { mO=!mO; upd(mecB, mO, mecT); });
          })
          .catch(() => {});
      })();

/* === block 4471-4532 === */
  /* "Aggiungi" via DELEGAZIONE: funziona per i bottoni attuali E per quelli clonati nel modal */
  (function(){
    if (window.__frelAtcBound) return; window.__frelAtcBound = true;
    document.addEventListener('click', function(e){
      var el = e.target.closest('[data-frog-atc]');
      if (!el) return;
      e.preventDefault();
      if (el.classList.contains('is-added')) return;

      var variantId = el.getAttribute('data-variant-id');
      var origHTML = el.innerHTML;

      el.innerHTML = '<svg style="width:15px;height:15px;animation:frog-spin .5s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4m-3.93 7.07l-2.83-2.83M7.76 7.76L4.93 4.93"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        el.classList.add('is-added');
        el.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        setTimeout(function(){ el.classList.remove('is-added'); el.innerHTML = origHTML; }, 2500);
      })
      .catch(function(){
        el.innerHTML = '!';
        setTimeout(function(){ el.innerHTML = origHTML; }, 2000);
      });
    });
  })();

  /* Modal "vedi tutto": clona la lista del blocco; chiusura smart (X / fuori / ESC) */
  (function(){
    var modal = document.getElementById('frel-modal');
    if (!modal) return;
    /* FIX: sposta il modal sul <body> così position:fixed si aggancia allo schermo
       e non a un antenato con transform/overflow (la sezione prodotto è animata) */
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var body = modal.querySelector('.frel-modal__body');
    var titleEl = modal.querySelector('.frel-modal__title');
    function open(){ modal.hidden = false; modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close(){ modal.classList.remove('is-open'); modal.hidden = true; document.body.style.overflow = ''; }
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-rel-open]');
      if (btn){
        var blk = btn.closest('.frel-blk'); if (!blk) return;
        var list = blk.querySelector('.frel-list');
        if (!list) return;
        body.innerHTML = '';
        body.appendChild(list.cloneNode(true));
        titleEl.textContent = btn.getAttribute('data-rel-title') || '';
        open();
        return;
      }
      if (e.target === modal || e.target.closest('.frel-modal__x')) close();
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  })();

/* === block 5972-6069 === */
  /* ── Sticky cutoff timer su mobile (product-sticky-form) ──
     Mostra il countdown di spedizione direttamente nella sticky bar.
     Si attiva solo su mobile (< 1024px) e solo se il prodotto
     non è in preordine o esaurito. */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(min-width: 1024px)').matches) return;

    var el = document.getElementById('StickyCutoff-' + window.FROG_PDP.sectionId);
    if (!el) return;

    var isPreorder = window.FROG_PDP.isPreorder;
    if (isPreorder) return;

    var pad = function (n) { return String(n).padStart(2, '0'); };
    var getRomeNow = function () {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' }));
    };

    var easterDate = function (year) {
      var a = year % 19, b = Math.floor(year / 100), c = year % 100,
          d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
          g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
          i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
          m = Math.floor((a + 11 * h + 22 * l) / 451),
          month = Math.floor((h + l - 7 * m + 114) / 31),
          day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month - 1, day);
    };

    var isSameDay = function (d1, d2) {
      return d1.getFullYear() === d2.getFullYear()
        && d1.getMonth() === d2.getMonth()
        && d1.getDate() === d2.getDate();
    };

    var isHoliday = function (date) {
      var fixed = ['01-01','01-06','04-25','05-01','06-02','08-15','11-01','12-08','12-25','12-26'];
      var key = pad(date.getMonth() + 1) + '-' + pad(date.getDate());
      if (fixed.indexOf(key) > -1) return true;
      var easter = easterDate(date.getFullYear());
      var easterMon = new Date(easter);
      easterMon.setDate(easterMon.getDate() + 1);
      return isSameDay(date, easter) || isSameDay(date, easterMon);
    };

    var isBusinessDay = function (date) {
      var d = date.getDay();
      return d !== 0 && d !== 6 && !isHoliday(date);
    };

    /* PAUSA OTTOBRE 2026 (solo quest'anno, non si ripete): spedizioni ferme da martedì 13 ore 11:00 a venerdì 16 ore 11:00.
       Dopo il 16 alle 11 riprende da solo il timer normale (prossimo giorno lavorativo). Non si promette una data di partenza.
       Gli stessi orari stanno in snippets/shipping-pause-popup.liquid e snippets/pausa-spedizioni-carrello.liquid.
       Si confronta con Date.now() (assoluto), non con l'ora di Roma convertita: il fuso del telefono non conta. */
    var SHIPPING_PRE_START = new Date('2026-10-12T20:00:00+02:00');
    var SHIPPING_PAUSE_START = new Date('2026-10-13T11:00:00+02:00');
    var SHIPPING_PAUSE_END = new Date('2026-10-16T11:00:00+02:00');
    var isEN = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
    var isShippingPaused = function () {
      var t = Date.now();
      return t >= SHIPPING_PAUSE_START.getTime() && t < SHIPPING_PAUSE_END.getTime();
    };
    var isPrePause = function () {
      var t = Date.now();
      return t >= SHIPPING_PRE_START.getTime() && t < SHIPPING_PAUSE_START.getTime();
    };

    var update = function () {
      var now = getRomeNow();
      var cutoff = new Date(now);
      cutoff.setHours(11, 0, 0, 0);

      if (isShippingPaused()) {
        el.style.display = '';
        el.className = 'sticky-cutoff-line';
        var isFridayS = now.getDay() === 5;
        el.textContent = isEN
          ? (isFridayS ? '📦 Warehouse move: back to normal from 11 am today' : '📦 Warehouse move: back to normal from Friday 11 am')
          : (isFridayS ? '📦 Cambio magazzino: dalle 11 di oggi tutto normale' : '📦 Cambio magazzino: da venerdì ore 11 tutto normale');
        return;
      }

      /* Niente piu' countdown con orario limite: la barra sticky resta vuota fuori dalla pausa */
      el.style.display = 'none';
    };

    update();
    setInterval(update, 1000);
  });


/* ===== VIDEO — play IN LINEA (nessun modal): al click l'iframe sostituisce la copertina ===== */
(function(){
  if (window.__frogVideoBound) return; window.__frogVideoBound = true;
  document.addEventListener('click', function(e){
    var cover = e.target.closest('.frog-video-cover');
    if (!cover) return;
    var card = cover.closest('[data-frog-video]');
    if (!card || card.querySelector('.frog-video-iframe')) return;   /* già in play */
    var id = card.getAttribute('data-frog-video');
    if (!id) return;
    e.preventDefault();
    var ifr = document.createElement('iframe');
    ifr.className = 'frog-video-iframe';
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    ifr.title = 'Video di gioco';
    ifr.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    ifr.setAttribute('allowfullscreen', '');
    card.appendChild(ifr);
    cover.remove();   /* via la copertina: resta solo il video nello stesso riquadro */
  });
})();
